import React from 'react';

import { Heading, Slide } from '../components';

export default () => (
  <Slide>
    <Heading fit>Thank you!</Heading>
  </Slide>
);
